export const contentJson = {
  projectTableHeader: {
    projectName: "Project Name",
    status: "Status",
    progress: "Progress",
    members: "Members",
  },
  projectCreationTabBar: {
    settings: "SETTINGS",
    features: "FEATURES",
  },
  labels: {
    projects: "Projects",
    projectDetails: "Project Details",
    member: "Member",
    projectLead: "PROJECT LEAD",
    defaultAssignee: "DEFAULT ASSIGNEE",
    startDate: "START DATE",
    endDate: "END DATE",
    archiveProject: "Archive Project",
    createdOn: "Created on",
    remove: "Remove",
    addMember: "Add Member to Project",
    addMemberDesc: "Start to type member’s name/email to add them to",
    cancel: "Cancel",
    add: "Add",
    archive: "Archive",
    showSidebar: "Show in sidebar",
    hideSidebar: "Hide in sidebar",
    projectDescriptionPlaceholder: "Enter project description here",
    noProjects: "No projects",
    archiveProjectMessage: "Are you sure that you want to archive",
    projectColors: "Project colors",
    upload: "Upload",
    uploadAvatar: "Upload Project Avatar",
    removeMember: "Remove member",
    removeMemberMessage: "Are you sure that you want to remove",
    owner: "Owner",
    addMemberPlaceholder: "Enter member(s) name/email",
    addNewProject: "Add new project",
    projectIconAndName: "Project icon & name",
    projectLeadsLabel: "Project lead",
    defaultAssigneeLabel: "Default assignee",
    projectLeadPlaceholder: "Choose project lead",
    defaultAssigneePlaceholder: "Choose default assignee",
    searchPlaceholder: "Search by assignee or role",
    projectDescription: "Project description",
    startFromScratch: "Start from scratch",
    copyProjectSettings: "Copy project settings",
    projectSettings: "Project settings",
    selectProjectDetails:
      "Select the project details you want to copy to the new project.",
    members: "Members",
    workItemsAndWorkflow: "Work Items & Workflow",
    simpleWorkflow: "Simple Workflow",
    customFields: "Custom fields",
    projectResourcesManagement: "Project Resources Management",
    epicsAndStories: "Epics and Stories",
    qaTesting: "QA Testing",
    agileDevelopmentAndSprints: "Agile Development and Sprints",
    releasesManagement: "Releases Management",
    features: "Features",
    featuresDescription:
      "Configure which features to enable for your new project.",
    projectNameExists: "Project name already exists",
    memberAddWithEmailToast:
      "This email address is not associated with your team. An invitation to join TechMate and access this project will be sent shortly. ",
  },
  memberTableHeader: {
    memberName: "Member Name",
    email: "Email",
    role: "Role",
    status: "Status",
    lastLogin: "Last login",
  },
  projectTabBar: {
    settings: "SETTINGS",
    components: "COMPONENTS",
    members: "MEMBERS",
    workflow: "WORKFLOW",
    workItems: "WORK ITEMS",
    customFields: "CUSTOM FIELDS",
  },
  customfds: {
    tableHeader: {
      type: "Type",
      name: "Name",
      ticketTypes: "Ticket Types",
      permission: "Permission",
      mandatory: "Mandatory ",
      edit: "Edit",
      archive: "Archive",
    },
    add:"Add",
    customFields: "Custom Fields",
    addCustomField: "Add Custom Field",
    addCustomFieldDes: "Choose a custom field to add to the work item, or create a new one.",
    newCustomField: "New custom field",
    fieldName: "Field Name",
    fieldType: "Field Type",
    fieldTooltip: "Field Tooltip",
    extraParameters: "Extra parameters",
    mandatoryField: "Mandatory Field",
    cancel: "Cancel",
    addField: "Add Field",
    noCustomFields: "No custom fields added yet.",
    editCustomField: "Edit Custom Field",
    customFieldDetails: "Custom field details",
    emptyFieldValue: "Empty field value",
    emptyFieldValuePlaceholder: "Enter empty field value",
    tooltip: "Tooltip",
    tooltipPlaceholder: "Enter Tooltip",
    labelValues: {
      title: "Labels values", 
      buttonText: "Value",
      edit: "Edit",
      remove: "Remove",
      inputPlaceholder: "Enter tag name",
    },
    dropdownValues: {
      title: "Dropdown values",
      buttonText: "Value",
      remove: "Remove",
      inputPlaceholder: "Enter value",
      select: "Select as a default value",
      defaultValue: "Default value",
    },
    archive: {
      title: "Archive custom field",
      buttonText: "Archive",
      description:
        "Are you sure that you want to archive custom field “{{title}}”?",
    },
    duplicate: {
      buttontext: "Create duplicate field",
      title: "Existing Custom Field",
      description:
        "An existing field with this name and type already exists in this project. Do you want to create a duplicate?",
    },
    fieldTypeFields: {
      textInput: "Text input",
      longTextInput: "Long Text input",
      dropdown: "Dropdown",
      date: "Date",
      number: "Number",
      entitySingleSelect: "Entity single select",
      entityMultiSelect: "Entity multi select",
      labels: "Labels",
      url: "URL",
      teamMemberSelection: "Team member selection",
      releaseSelection: "Release selection",
      ticketSelection: "Ticket selection",
    },
  },
};
